<template>
  <div>
    <v-radio-group
      v-model="sourceGroup"
      @change="addSources"
      row
      :class="className"
    >
      <v-radio
        v-for="source in availableSources"
        :key="source.id"
        :label="source.display"
        :value="source.id"
        :class="{
          small: size === 'small',
          large: size === 'large',
        }"
      ></v-radio>
    </v-radio-group>
  </div>
</template>
<script>
import lodashFind from "lodash/find";

import { hasTwitterAccess } from "@/services/user/user.service";
import {
  getSources,
  getDefaultSources,
} from "@/services/alerts/alerts.service.js";
import { upperCaseFirstLetter } from "@/common/basic.utilities";

const EMITTED_ACTIONS = {
  INPUT: "input",
};

export default {
  name: "SourcesEditor",
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    className: {
      type: String,
    },
    size: {
      validator: function (value) {
        return ["small", "large"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    const selectedSources = this.value
      ? JSON.parse(JSON.stringify(this.value))
      : [];

    const sources = getSources();

    return {
      sourceGroup: null,
      selectedSources: selectedSources,
      possibleSources: sources,
    };
  },
  mounted() {
    this.updateSources();
    if (!this.value || this.value.length === 0) {
      this.$emit(EMITTED_ACTIONS.INPUT, getDefaultSources());
    }
  },
  computed: {
    availableSources() {
      let sources = [];
      const NEWS = this.news;
      const SOCIAL = this.social;
      const NEWS_DISPLAY =
        NEWS && NEWS.display ? upperCaseFirstLetter(NEWS.display) : null;
      const SOCIAL_DISPLAY =
        SOCIAL && SOCIAL.display ? upperCaseFirstLetter(SOCIAL.display) : null;

      sources.push({
        id: NEWS.id,
        display: `Only ${NEWS_DISPLAY}`,
      });

      if (SOCIAL) {
        sources.unshift({
          id: "both",
          display: `${NEWS_DISPLAY} & ${SOCIAL_DISPLAY}`,
        });
        sources.push({
          id: SOCIAL.id,
          display: `Only ${SOCIAL_DISPLAY}`,
        });
      }
      return sources;
    },
    news() {
      return lodashFind(this.possibleSources, ["id", "news-all"]);
    },
    social() {
      return hasTwitterAccess()
        ? lodashFind(this.possibleSources, ["id", "twitter"])
        : null;
    },
  },
  methods: {
    addSources(value) {
      let sources = [];
      const NEWS = this.news;
      const SOCIAL = this.social;
      if (NEWS && NEWS.id && value === NEWS.id) {
        sources.push(NEWS);
      } else if (SOCIAL && SOCIAL.id && value === SOCIAL.id) {
        sources.push(SOCIAL);
      } else {
        sources.push(NEWS);
        sources.push(SOCIAL);
      }
      this.$emit(EMITTED_ACTIONS.INPUT, sources);
    },
    updateSources() {
      let source = this.news.id;
      if (this.selectedSources && this.selectedSources.length) {
        if (this.news && this.social && this.selectedSources.length > 1) {
          source = "both";
        }
        if (this.social && this.selectedSources[0].id === this.social.id) {
          source = this.social.id;
        }
      }
      this.sourceGroup = source;
    },
  },
  watch: {
    value() {
      let val = this.value;
      if (!val || val.length === 0) {
        val = getDefaultSources();
      }
      this.selectedSources = JSON.parse(JSON.stringify(val));
      this.updateSources();
    },
  },
};
</script>

<style>
.small.v-radio {
  padding: 0 !important;
}
div.small i {
  font-size: 18px !important;
}
div.small label {
  font-size: 14px !important;
  margin-left: -10px !important;
}
div.small [class*="__ripple"] {
  left: -15px !important;
}

.large.v-radio {
  padding: 10px !important;
}
.large i {
  font-size: 30px !important;
}
.large label {
  padding-left: 15px !important;
}
.large [class*="__ripple"] {
  left: 0 !important;
}
</style>

<style scoped>
.source-check-box {
  float: left;
  margin-right: 15px;
}
</style>
